import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ControlledComboboxV2 } from '@packages/components/controls/controlled-combobox-v2/controlled-combobox-v2';
import { ControlledDateTimePicker } from '@packages/components/controls/controlled-date-time-picker/controlled-date-time-picker';
import { ControlledSelectV2 } from '@packages/components/controls/controlled-select-v2/controlled-select-v2';
import { Stack } from '@packages/fenrir/components';
import { useFormFieldSelectionTransform } from '@packages/hooks/use-form-field-selection-transform/use-form-field-selection-transform';

import { riskStateOptions } from '../../filter-management/select-options/select-options';
import { useGetUsersListOptions } from '../../hooks/use-get-users-list-options/use-get-users-list-options';

import type { FormValues } from './update-risk-form';

export const UpdateRiskFormFields = () => {
  const { data: assignedToOptions, isLoading: isUserListLoading } =
    useGetUsersListOptions();
  const { t } = useTranslation('riskManagement');
  const { t: tUi } = useTranslation('ui');

  const { control } = useFormContext<FormValues>();

  const fieldSelectorTransform = useFormFieldSelectionTransform(
    assignedToOptions ?? [],
  );

  return (
    <Stack sx={{ flexGrow: 1, mb: 2 }} spacing={3}>
      <ControlledSelectV2
        controllerProps={{
          name: 'state',
          control,
        }}
        label={t('risks.state')}
        options={riskStateOptions}
        placeholder={tUi('select')}
      />

      <ControlledComboboxV2
        controllerProps={{
          name: 'assignedTo',
          control,
        }}
        autoCompleteProps={{
          options: assignedToOptions ?? [],
          renderOption: (props, option) => (
            <li {...props} key={option.value}>
              {option.label}
            </li>
          ),
          loading: isUserListLoading,
        }}
        label={t('risks.assignedTo')}
        outlinedInputProps={{ placeholder: tUi('select') }}
        transform={fieldSelectorTransform}
      />

      <ControlledDateTimePicker
        control={control}
        name="dueDate"
        label={t('risks.dueDate')}
        format="MM-DD-YYYY HH:mm:ss"
        textFieldProps={{ fullWidth: true }}
        clearable
      />
    </Stack>
  );
};
